import React, { PropTypes } from 'react'
import styles from './ContentHeader.scss'
import CSSModules from 'react-css-modules'

const ContentHeader = ({ title, icon }) => (
    <div styleName="container">
        <h1 className="ellipsis" styleName="title">
            { !!icon && <i styleName="icon">{ icon }</i> }
            { title }
        </h1>
    </div>
);

ContentHeader.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node,
};

export default CSSModules(ContentHeader, styles);


// WEBPACK FOOTER //
// ./app/components/shared/ContentHeader/index.jsx